import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import type { CouponTypeSB } from '@mwl/core-lib';
import { selectCouponPossibleTypesV2, selectCouponTypeV2, setCouponTypeV2 } from '@mwl/core-lib';
import { Tabs } from '@mwl/ui';
import { Tab } from '@/components/Tab/Tab';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { couponTypeTranslations } from '../../SportCoupon.data';
import { CouponSystemRegularity } from '../CouponSystemRegularity/CouponSystemRegularity';
import type { CouponTabsContent, CouponTypeSelectProps } from './CouponTypeSelect.types';
import styles from './CouponTypeSelect.module.scss';
const CouponTypeSelect: FC<CouponTypeSelectProps> = () => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const selectedType = useTypedSelector(selectCouponTypeV2);
  const possibleTypes = useTypedSelector(selectCouponPossibleTypesV2);
  const handleClick = useCallback((type: CouponTypeSB) => {
    dispatch(setCouponTypeV2(type));
  }, [dispatch]);
  return <Tabs className={styles.root} justify="center" data-sentry-element="Tabs" data-sentry-component="CouponTypeSelect" data-sentry-source-file="CouponTypeSelect.tsx">
      {(Object.keys(couponTypeTranslations) as Keys<CouponTabsContent>).map(type => <Tab as="button" label={<>
              <span className={styles.tabContent}>{t(couponTypeTranslations[type])}</span>
              {type === 'SYSTEM' && <CouponSystemRegularity active={selectedType === type} />}
            </>} key={type} onClick={() => handleClick(type)} value={type} disabled={!possibleTypes.includes(type)} fontSize="md" active={selectedType === type} className={styles.tab} />)}
    </Tabs>;
};
export { CouponTypeSelect };